import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';

import CatalogHeader from 'rebook/apps/catalog/components/CatalogHeader';
import CatalogFilter from 'rebook/apps/catalog/components/Filters/CatalogFilter';
import EmptyFilterResult from 'rebook/apps/base/components/EmptyFilterResult';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BookList from 'rebook/apps/books/components/BookList';
import * as CatalogBookListActions from 'rebook/apps/catalog/actions/CatalogBookListActions';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';


class CatalogBookListView extends React.Component {
  static fetchInitialDataForServer(match, store) {
    return store.dispatch(CatalogBookListActions.fetchInitialData(match));
  }

  componentDidMount() {
    const { match, location } = this.props;
    this.props.CatalogBookListActions.fetchInitialData(match, location);
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    const { match: prevMatch } = prevProps;

    if (match.url !== prevMatch.url) {
      this.props.CatalogBookListActions.fetchBookList(this.props.catalogBookList, match);
    }
  }

  changePage(pageNumber) {
    window.scrollTo(0, 0);
    this.props.CatalogBookListActions.fetchBookList({ pageNumber }, this.props.match);
  }

  onChangeOrderBy(orderBy) {
    this.props.CatalogBookListActions.fetchBookList({ orderBy }, this.props.match);
  }

  onChangeSubscriptionType(subscriptionId) {
    this.props.CatalogBookListActions.fetchBookList({ subscriptionId }, this.props.match);
  }

  onChangeBookType(bookType) {
    this.props.CatalogBookListActions.fetchBookList({ bookType }, this.props.match);
  }

  onResetFilter() {
    this.props.CatalogBookListActions.fetchBookList({
      subscriptionId: null,
      orderBy: 'popular',
      bookType: null,
    });
  }

  render() {
    const {
      books, orderBy, subscriptionId, pageNumber, lastPageNumber, bookType,
    } = this.props.catalogBookList;
    const { bookType: catalogBookType } = this.props.match.params;
    const { booksPerSubscriptionCounter } = this.props;
    const titlesMapper = {
      free: {
        header: 'Все бесплатные книги',
        breadCrumbs: 'Бесплатные книги',
      },
      total: {
        header: 'Все книги',
        breadCrumbs: 'Все книги',
      },
      audio: {
        header: 'Все аудиокниги',
        breadCrumbs: 'Аудиокниги',
      },
    };
    const headerBookCount = booksPerSubscriptionCounter[catalogBookType] || booksPerSubscriptionCounter.total;
    const headerTitle = get(titlesMapper, `[${catalogBookType}].header`, titlesMapper.total.header);
    return (
      <div className="section">
        <BreadCrumbs links={[
          { text: 'Библиотека', url: '/catalog/' },
          { text: get(titlesMapper, `[${catalogBookType}].breadCrumbs`, titlesMapper.total.breadCrumbs), url: '' },
        ]} />
        <CatalogHeader
          title={headerTitle}
          bookType={catalogBookType === 'audio' ? catalogBookType : 'text'}
          bookCount={headerBookCount} />
        <CatalogFilter
          orderBy={orderBy}
          isSubscriptionEnabled={!(catalogBookType === 'audio' || catalogBookType === 'free')}
          subscriptionId={subscriptionId}
          bookType={bookType}
          isBookTypeEnabled={!(catalogBookType === 'audio' || catalogBookType === 'free')}
          isResultEmpty={books && books.length === 0}
          onChangeSubscription={(value) => this.onChangeSubscriptionType(value)}
          onChangeOrder={(value) => this.onChangeOrderBy(value)}
          onChangeBookType={((value) => this.onChangeBookType(value))}
          onResetFilter={()=>this.onResetFilter()} />
        {!books
          ? <BookList books={[...Array(6)]} />
          : <BookList books={books} />
        }
        {books && books.length === 0 && <EmptyFilterResult /> }
        {lastPageNumber > 1 && (
          <ContextPagination
            onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
            currentPage={pageNumber}
            lastPage={lastPageNumber} />
        )}
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    catalogBookList: state.catalogBookList,
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    CatalogBookListActions: bindActionCreators(CatalogBookListActions, dispatch),
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CatalogBookListView);
